<template>
  <div
    class="remark-card"
    :class="{white:white,noPadding:noPadding,noBg:noBg}"
    :style="{marginTop:marginTop+'px'}"
  >
    <div class="card-title-wrap">
      <div class="title-content">
        <p
          class="card-title"
          :class="{'small-title':smallTitle}"
        >
          {{ $t(title) }}
        </p>
        <div
          v-if="!remarkEdit && time"
          class="title-item date"
        >
          <i class="icon-time" />
          <p>{{ $t('編輯時間') }} {{ $_getDateFormat(time) }}</p>
        </div>
        <div
          v-if="!remarkEdit && userName"
          class="title-item"
        >
          <LlAvatar
            :text-label="userName"
            :image="userAvatar"
            bold
          />
        </div>
      </div>
      <div
        v-if="remarkEditable"
        class="btns"
      >
        <div
          v-if="!remarkEdit && !noBtn"
          class="btn"
        >
          <WsButton001
            out-line
            width-stretch
            flat-button
            @click="$_remarkEditOpen()"
          >
            {{ btnText }}
          </WsButton001>
        </div>
        <div
          v-if="remarkEdit"
          class="btn"
        >
          <WsButton001
            out-line
            width-stretch
            flat-button
            @click="$_remarkEditClose()"
          >
            {{ $t('取消') }}
          </WsButton001>
        </div>
        <div
          v-if="remarkEdit"
          class="btn"
        >
          <WsButton001
            width-stretch
            flat-button
            @click="remarkEditSave()"
          >
            {{ $t('送出') }}
          </WsButton001>
        </div>
      </div>
    </div>
    <div
      v-if="remarkEdit"
      class="card-content"
    >
      <InputTextareaButton
        v-model="remarkEditContent"
        :placeholder="$t('輸入')"
        :min-height="90"
        :max-height="350"
      />
    </div>
    <div
      v-else
      class="card-content"
    >
      <p
        class="card-text"
        :class="{smallText:smallText}"
      >
        {{ value ? value : noRemarkText }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "RemarkCard",
  props: {
    btnText: {
      type: String,
      default: function () {
        return this.$t("編輯");
      },
    },
    title: {
      type: String,
      default: "",
    },
    userName: {
      type: String,
      default: "",
    },
    userAvatar: {
      type: String,
      default: "",
    },
    time: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    updateUrl: {
      type: String,
      default: "",
    },
    white: {
      type: Boolean,
      default: false,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
    noBg: {
      type: Boolean,
      default: false,
    },
    marginTop: {
      type: Number,
      default: 40,
    },
    noRemarkText: {
      type: String,
      default() {
        return this.$t("無");
      },
    },
    smallText: {
      type: Boolean,
      default: false,
    },
    smallTitle: {
      type: Boolean,
      default: false,
    },
    noBtn: {
      type: Boolean,
      default: false,
    },
    remarkEditable: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    remarkEdit: false,
    remarkEditContent: "",
  }),
  methods: {
    $_remarkEditOpen() {
      this.remarkEditContent = JSON.parse(JSON.stringify(this.value));
      this.remarkEdit = true;
    },
    $_remarkEditClose() {
      this.remarkEdit = false;
      this.remarkEditContent = this.value;
    },
    remarkEditSave() {
      this.$emit("input", this.remarkEditContent);
      this.$emit("click");
      this.remarkEdit = false;
    },
    $_getDateFormat(date) {
      if (!date) return;
      return this.$moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/remark-card";
</style>